export default "__VITE_ASSET__DHpq1Dnk__"